import Vue from 'vue'
import Vuex from 'vuex'
import appService from '../server/app.service'
import dashboardModule from './modules/dashboard'
import usersModule from './modules/users'
import projectsModule from './modules/projects'
import scriptTypesModule from './modules/scriptTypes'
import languagesModule from './modules/languages'
import librariesModule from './modules/libraries'
import translationsModule from './modules/translations'
import settingsModule from './modules/settings'
import rolesModule from './modules/roles'
import _ from 'lodash'

import { getField, updateField } from 'vuex-map-fields';

Vue.use(Vuex)

const state = {
    isAuthenticated: false,
    miniVariant:false,
    messages: [],
    privilegies: {},
    isSuperAdmin: false,
    user: {},
    debugFailedCount: 0,
}

const store = new Vuex.Store({
    modules: {
        dashboardModule,
        usersModule,
        projectsModule,
        scriptTypesModule,
        librariesModule,
        languagesModule,
        translationsModule,
        settingsModule,
        rolesModule
    },
    state,
    getters: {
        isAuthenticated: (state) => {
            return state.isAuthenticated
        },
        miniVariant: (state) => {
            return state.miniVariant
        },
        messages: (state) => {
            return state.messages
        },
        privilegies: (state) => {
            return state.privilegies
        },
        isSuperAdmin: (state) => {
            return state.isSuperAdmin
        },
        user: (state) => {
            return state.user
        },
        debugFailedCount: (state) => {
            return state.debugFailedCount
        },
        isReadOnly:(state) => (moduleName, action = null) => {
            if (state.isSuperAdmin) return false;
            const modulePrivs = state.privilegies[moduleName];
            if (!modulePrivs) return false;
            if (!action) return true;
            return !!modulePrivs[action];
        },
        hasPermission: (state) => (moduleName, action = null) => {
            if (state.isSuperAdmin) return true;
            const modulePrivs = state.privilegies[moduleName];
            if (!modulePrivs) return false;
            if (!action) return true;
            return !!modulePrivs[action];
        },
        getField,
    },
    actions: {
        changeMiniVariant(context) {
            context.commit('changeMiniVariant')
        },
        logout (context) {
            context.commit('logout')
        },
        login (context, credentials) {
            return new Promise((resolve) => {
                appService.connectToServer(credentials)
                    .then((data) => {
                        context.commit('login', data)
                        resolve()
                    })
                    .catch(() => window.alert('Could not login!'))
            })
        },
        microsoftLogin (context, credentials) {
            return new Promise((resolve) => {
                appService.connectToServer(credentials)
                    .then((data) => {
                        context.commit('microsoftLogin', data)
                        resolve()
                    })
                    .catch(() => window.alert('Could not login!'))
            })
        },
        me (context, credentials) {
            return new Promise((resolve) => {
                appService.connectToServer(credentials)
                    .then((data) => {
                        context.commit('me', data)
                        resolve()
                    })
                    .catch(() => window.alert('Could not login!'))
            })
        },
        changeAuthenticated: (context, value) => {
            context.commit('changeAuthenticated', value)
        },
        addMessage (context, content) {
            context.commit('addMessage', content)
        },
        deleteMessage (context, id) {
            context.commit('deleteMessage', id)
        },
        loadDebugFailedCount (context) {
            return appService.connectToServer({
                urlToConnect: 'debug/count',
                methodToConnect: 'get',
            }).then((data) => {
                context.commit('setDebugFailedCount', data && data.count ? data.count : 0)
            }).catch(() => {
                context.commit('setDebugFailedCount', 0)
            })
        },
    },
    mutations: {
        changeMiniVariant (state) {
            if (typeof window !== 'undefined') {
                window.localStorage.setItem('miniVariant', !state.miniVariant)
            }
            state.miniVariant = !state.miniVariant
        },

        logout (state) {
            if (typeof window !== 'undefined') {
                window.localStorage.setItem('token', null)
                window.localStorage.setItem('tokenExpiration', null)
                window.localStorage.setItem('role_id', 0)
            }
            state.isAuthenticated = false
            state.privilegies = {}
        },
        setDebugFailedCount (state, count) {
            state.debugFailedCount = count
        },
        login (state, loginData) {
            if(loginData.success) {
                if (typeof window !== 'undefined') {
                    window.localStorage.setItem('token', loginData.token)
                    window.localStorage.setItem('role_id', loginData.role_id)
                    var tokenExpiration = (new Date().getTime() / 1000) + loginData.expires_in
                    window.localStorage.setItem('tokenExpiration', tokenExpiration)
                }
                state.isAuthenticated = true
            } else {
                state.isAuthenticated = false
                this.dispatch('addMessage', loginData)
            }

        },
        microsoftLogin (state, loginData) {
            if(loginData.success) {
                if (typeof window !== 'undefined') {
                    window.localStorage.setItem('token', loginData.token)
                    window.localStorage.setItem('role_id', loginData.role_id)
                    var tokenExpiration = (new Date().getTime() / 1000) + loginData.expires_in
                    window.localStorage.setItem('tokenExpiration', tokenExpiration)
                }
                state.isAuthenticated = true
            } else {
                state.isAuthenticated = false
                this.dispatch('addMessage', loginData)
            }

        },
        me (state, data) {
            if(data.success) {
                if(data.role.id === 1){
                    state.privilegies = {}
                    state.isSuperAdmin = true
                } else {
                    state.privilegies = data.role.privilegies
                    state.isSuperAdmin = false
                }
                state.user = data.user
            } else {
                state.privilegies = {}
                state.isSuperAdmin = false
                state.user = {}
            }

        },
        changeAuthenticated: (context, value) => {
            state.isAuthenticated = value
        },
        addMessage (state, content) {
            state.messages.push({id: parseInt(Math.random() * 100000), msg: content})
        },
        deleteMessage (state, id) {
            let index = _.findIndex(state.messages, function(o) { return o.id == id })
            state.messages.splice(index, 1)
        },
        updateField,
    }

})

if (typeof window !== 'undefined') {

        if (typeof  window.localStorage.getItem('miniVariant') !== 'undefined') {
            store.state.miniVariant = JSON.parse(window.localStorage.getItem('miniVariant'));
        }
        // controllo il token
        let expiration = window.localStorage.getItem('tokenExpiration')
        var unixTimestamp = new Date().getTime() / 1000

        if (expiration !== null && parseInt(expiration) - unixTimestamp > 0) {
            store.state.isAuthenticated = true
        }

        /*let token = window.localStorage.getItem('token')
        if(token != '' && token != 'null') {
            store.state.isAuthenticated = true
        }*/

}


export default store
